<template>
  <v-dialog v-model="value" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        {{ $t(title) }}
        <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name : 'pr-loading',
    props : {
        value : {
            type : Boolean
        },
        title : {
            type   : String,
            default: 'Loading... Please stand by'
        }
    }
}
</script>